import { z } from "zod";

const markSchema = z.object({
  type: z.string(),
  attrs: z.record(z.any()).optional(),
});
export type Mark = z.infer<typeof markSchema>;

const textNodeSchema = z.object({
  type: z.literal("text"),
  text: z.string(),
  marks: z.array(markSchema).optional(),
});
export type TextNode = z.infer<typeof textNodeSchema>;

const blockNodeSchema: z.ZodType<BlockNode> = z.object({
  type: z.string(),
  attrs: z.record(z.any()).optional(),
  content: z.lazy(() => nodeSchema.array()).optional(),
});
export type BlockNode = {
  type: string;
  attrs?: Record<string, any>;
  content?: TiptapNode[];
};

const nodeSchema: z.ZodType<TiptapNode> = z.lazy(() =>
  z.union([textNodeSchema, blockNodeSchema]),
);
export type TiptapNode = TextNode | BlockNode;

export const tiptapSchema = z.object({
  type: z.literal("doc"),
  content: nodeSchema.array(),
});
export type TiptapDocument = {
  type: "doc";
  content: TiptapNode[];
};
